const MARGIN = 8
const GAP = 10
const MAX_WIDTH = 360
const MIN_WIDTH = 200

export function placeHelpPanel({
  anchor,
  panelHeight,
  viewportWidth,
  viewportHeight,
  align = 'center',
  gap = GAP,
  margin = MARGIN,
  maxWidth = MAX_WIDTH,
}) {
  const width = Math.min(maxWidth, Math.max(MIN_WIDTH, viewportWidth - margin * 2))
  const height = Math.max(1, panelHeight)
  const spaceBelow = viewportHeight - anchor.bottom - margin
  const spaceAbove = anchor.top - margin
  const placeBelow = spaceBelow >= Math.min(height, 96) || spaceBelow >= spaceAbove

  let top = placeBelow ? anchor.bottom + gap : anchor.top - height - gap
  top = Math.max(margin, Math.min(top, Math.max(margin, viewportHeight - height - margin)))

  let left = align === 'end'
    ? anchor.right - width
    : anchor.left + (anchor.width - width) / 2
  left = Math.max(margin, Math.min(left, viewportWidth - width - margin))

  return {
    top,
    left,
    width,
    maxHeight: Math.max(96, viewportHeight - margin * 2),
    placement: placeBelow ? 'bottom' : 'top',
  }
}
